module.exports = __webpack_public_path__ + "static/media/maxSuccessionWins_100.e41871ab.png";